module.exports = __webpack_public_path__ + "static/media/Student.2d6a69e9.png";